import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { forEach, findIndex } from 'lodash';
import Modal from '../common/Modal/Modal';
import CommonStudySelector from '../common/CommonStudySelector';
import SmartSearch from '../common/SmartSearch/SmartSearch';
import basesIcon from '../../images/bases-small-icon_blue.png';
import basesHoverIcon from '../../images/bases-small-icon.png';
import enlargeIcon from '../../images/enlarge-icon_48-67-93.png';
import enlargeHoverIcon from '../../images/enlarge-icon_brown.png';
import targetIcon from '../../images/target-icon_blue.png';
import targetHoverIcon from '../../images/target-icon_red.png';
import { GEOMAPPING_FEATUREID } from '../../constants';
import { GEOGRAPHICS_TOP_NODE_VALUES_ON_STUDY_CHANGE } from "./GeoMapConstant";
import * as geoMappingActions from '../../actions/geoMappingActions';
import { getBaseAndTargetExpListOnStudyChange, getTableRequestsDataOnStudyChange,
  getStudyChangeValidationData, getTabNameForSamplewtApi, modifiedBaseAndTargetGridData,
  getGeoghrapicsData, getGeographicsTableDataOnStudyChange, getCountyData, getZipcodeData,
   updateStudyChangeValidTableData, hasGeoDataInTable,
  resetGeoTableDataWithZeroes, updateChildrenCounter,
 } from '../../util/geomapUtils';
import GeoMapStudyChangePopup from './GeoMapStudyChangePopup';
import { SELECT_GEOGRAPHICS_TAB_OPTIONS,
  GEO_MAP_MODULE, GEOMAPPING_BREADCRUMB, PARENT_MODULE } from "./GeoMapConstant";


const modalStyle = {
  minWidth: '682px',
  maxWidth: '682px',
  height: '393px',
  top: '10%',
  left: '30%',
  borderRadius: '15px',
};


class GeoMapSmartSearchEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // showViewerDisplayType: false,
      enlargeIcon: true,
      basesIcon: true,
      targetIcon: true,
      // runIcon: true,
      isTagInputExpanded: true,
      studyChangeInvalidData: [],
      studyChangeValidData: [],
      tempSelectedStudy: '',
      updatedWeightTypeOnStudyChange: '',
    };
    this.updatedSmartSearch = React.createRef();
  }

  onStudyChangeValidation = (selectedStudy, geoMapTarget, geoMapBase, updatedWeightType) => {
    const { activeAccountId, loginResponse, geographicsTableData } = this.props;
    Promise.all(this.studyChangeApiCallsFn(selectedStudy)).then(data => {
      if (data) {
        const { studyChangeValidData, studyChangeInvalidData } = getStudyChangeValidationData(data,
           geoMapTarget, geoMapBase);
        if (studyChangeInvalidData.length > 0) {
          this.setState({
            studyChangeInvalidData,
            studyChangeValidData,
            tempSelectedStudy: selectedStudy,
          });
          this.studyModal.show();
        } else {
          // updatting data on study change when every thing is valid
          // // getGeoghrapicsData data call for all tabs..
          this.setSelectedStudy(selectedStudy, updatedWeightType).then(() => {
            getGeoghrapicsData(activeAccountId, loginResponse, selectedStudy,
            this.props.geoMappingActions.getGeoghrapicsData);
            getCountyData(activeAccountId, loginResponse, selectedStudy,
              this.props.geoMappingActions.getGeoghrapicsData).then(() => {
                if (geographicsTableData.county.length) {
                  const { parentChildCountMap } = this.props;
                  updateChildrenCounter('county', geographicsTableData.county, false,
                  parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
                }
              });
            getZipcodeData(activeAccountId, loginResponse, selectedStudy,
              this.props.geoMappingActions.getGeoghrapicsData).then(() => {
                if (geographicsTableData.zipcode.length) {
                  const { parentChildCountMap } = this.props;
                  updateChildrenCounter('zipcode', geographicsTableData.zipcode, false,
                  parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
                }
              });
            if (geoMapTarget.length > 0 || geoMapBase.length > 0) {
              const { geoMapTargetGridData, geoMapBaseGridData } = modifiedBaseAndTargetGridData(
              studyChangeValidData,
              geoMapTarget,
              geoMapBase);
              this.props.geoMappingActions.updateBaseAndTargetOnStudyChange(
               geoMapTargetGridData, geoMapBaseGridData).then(() => {
                 if (geoMapTargetGridData.length === 0) {
                   const updatedGeoTableDatawithZeros =
                   resetGeoTableDataWithZeroes(this.props.geographicsTableData);
                   this.props.geoMappingActions.resetGeographicsTableDataWithZeros(
                  updatedGeoTableDatawithZeros);
                 } else {
                   this.props.resetAndUpdateGeoMapData();
                 }
               });
              
            }
          });
        }
      }
    });
  };

  onStudyChange = (selectedStudy, updatedWeightType) => {
    const { geoMapTarget, geoMapBase, geographicsTableData, activeAccountId,
      loginResponse } = this.props;
    this.setState({ updatedWeightTypeOnStudyChange: updatedWeightType });
     // study change validation when data is present in any of the tab
     // calling onStudyChangeValidation method when data is present any of the tabs
    if (geoMapTarget.length > 0 || geoMapBase.length > 0 || hasGeoDataInTable(geographicsTableData)
      ) {
      this.onStudyChangeValidation(selectedStudy, geoMapTarget, geoMapBase, updatedWeightType);
    } else {
      this.setSelectedStudy(selectedStudy, updatedWeightType).then(() => {
        getGeoghrapicsData(activeAccountId, loginResponse, selectedStudy,
          this.props.geoMappingActions.getGeoghrapicsData);
        getCountyData(activeAccountId, loginResponse, selectedStudy,
          this.props.geoMappingActions.getGeoghrapicsData).then(() => {
            if (geographicsTableData.county.length) {
              const { parentChildCountMap } = this.props;
              updateChildrenCounter('county', geographicsTableData.county, false,
              parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
            }
          });
        getZipcodeData(activeAccountId, loginResponse, selectedStudy,
          this.props.geoMappingActions.getGeoghrapicsData).then(() => {
            if (geographicsTableData.zipcode.length) {
              const { parentChildCountMap } = this.props;
              updateChildrenCounter('zipcode', geographicsTableData.zipcode, false,
              parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
            }
          });
      });
    }
  }

  setSelectedStudy = (selectedStudy, updatedWeightType) =>
    new Promise(resolve => {
      // this.setState(() => ({ actualWeightType: selectedStudy.weightType }));
      this.props.handleStudyChange(selectedStudy, updatedWeightType);
      resolve(true);
    });

  setTagInputData = () => {
    this.setState({
     // enlargeIcon: !this.state.enlargeIcon,
      isTagInputExpanded: !this.state.isTagInputExpanded,
    });
  }

  handleCancelClickOnStudyChange = () => {
    const { geoMapStudy } = this.props;
    this.commonStudySelectorRef.setStudyAsPreviousStudy(geoMapStudy);
    this.studyModal.hide();
  }

  handleValidateContinueClickOnStudyChange = () => {
    this.studyModal.hide();
    const { studyChangeInvalidData, studyChangeValidData, tempSelectedStudy,
      updatedWeightTypeOnStudyChange } = this.state;
    const { geographicsTableData, geoMapTarget, geoMapBase, activeAccountId,
       loginResponse } = this.props;
    const studyChangeValidTableDataArr = updateStudyChangeValidTableData(studyChangeInvalidData,
        geographicsTableData);
    getGeoghrapicsData(activeAccountId, loginResponse, tempSelectedStudy,
        this.props.geoMappingActions.getGeoghrapicsData);
    getCountyData(activeAccountId, loginResponse, tempSelectedStudy,
      this.props.geoMappingActions.getGeoghrapicsData).then(() => {
        if (studyChangeValidTableDataArr.length) {
          let parentChildCountMapCountyFlag = true;
          for (let i = 0; i < studyChangeValidTableDataArr.length; i+=1) {
            if (studyChangeValidTableDataArr[i].selectedTab === 'county') {
              parentChildCountMapCountyFlag = false;
              const { parentChildCountMap } = this.props;
              updateChildrenCounter('county', studyChangeValidTableDataArr[i].data, false,
              parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
            }
            if (geographicsTableData.county.length > 0 && parentChildCountMapCountyFlag === true) {
              parentChildCountMapCountyFlag = false;
              const { parentChildCountMap } = this.props;
              updateChildrenCounter('county', geographicsTableData.county, false,
              parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
            }
          }
        } else if (geographicsTableData.county.length) {
          const { parentChildCountMap } = this.props;
          updateChildrenCounter('county', geographicsTableData.county, false,
          parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
        }
      });
    getZipcodeData(activeAccountId, loginResponse, tempSelectedStudy,
      this.props.geoMappingActions.getGeoghrapicsData).then(() => {
        if (studyChangeValidTableDataArr.length) {
          let parentChildCountMapZipcodeFlag = true;
          for (let i = 0; i < studyChangeValidTableDataArr.length; i+=1) {
            if (studyChangeValidTableDataArr[i].selectedTab === 'zipcode') {
              parentChildCountMapZipcodeFlag = false;
              const { parentChildCountMap } = this.props;
              updateChildrenCounter('zipcode', studyChangeValidTableDataArr[i].data, false,
              parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
            }
            if (geographicsTableData.zipcode.length > 0 && parentChildCountMapZipcodeFlag === true) {
              parentChildCountMapZipcodeFlag = false;
              const { parentChildCountMap } = this.props;
              updateChildrenCounter('zipcode', geographicsTableData.zipcode, false,
              parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
            }
          }
        } else if (geographicsTableData.zipcode.length) {
          const { parentChildCountMap } = this.props;
          updateChildrenCounter('zipcode', geographicsTableData.zipcode, false,
          parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
        }
      });
    this.setSelectedStudy(tempSelectedStudy, updatedWeightTypeOnStudyChange).then(() => {
      if (geoMapTarget.length > 0 || geoMapBase.length > 0) {
        const { geoMapTargetGridData, geoMapBaseGridData } = modifiedBaseAndTargetGridData(
        studyChangeValidData,
        geoMapTarget,
        geoMapBase);
        this.props.geoMappingActions.updateBaseAndTargetOnStudyChange(
         geoMapTargetGridData, geoMapBaseGridData).then(() => {
           if (hasGeoDataInTable(geographicsTableData)) {
             Promise.all(this.resetGeographicsTableDataOnStudyChange(
               studyChangeValidTableDataArr)).then(() => {
                 if (geoMapTargetGridData.length === 0) {
                   const updatedGeoTableDatawithZeros =
                   resetGeoTableDataWithZeroes(this.props.geographicsTableData);
                   this.props.geoMappingActions.resetGeographicsTableDataWithZeros(
                   updatedGeoTableDatawithZeros);
                 } else {
                   this.props.resetAndUpdateGeoMapData();
                 }
               });
           }
         });
      } else {
        this.resetGeographicsTableDataOnStudyChange(studyChangeValidTableDataArr);
      }
    });
  }

  resetGeographicsTableDataOnStudyChange = studyChangeValidTableDataArr => {
    const studyChangeValidDataCallsArr = [];
    for (let i = 0; i < studyChangeValidTableDataArr.length; i += 1) {
      studyChangeValidDataCallsArr.push(getGeographicsTableDataOnStudyChange(
        studyChangeValidTableDataArr[i].data,
          studyChangeValidTableDataArr[i].selectedTab,
        this.props.geoMappingActions.setGeoghrapicsTableDataThunk));
    }
    return studyChangeValidDataCallsArr;
  }

  handleChangeWeightType = weightType => {
    const { geoMapStudy, geoMapBase, geoMapTarget, loginResponse,
      activeAccountId, updateWeightType } = this.props;
    updateWeightType(weightType, geoMapStudy);
    const studyChangeSampleWtExpList = getBaseAndTargetExpListOnStudyChange(geoMapTarget,
      geoMapBase);
    if (geoMapTarget.length > 0 || geoMapBase.length > 0) {
      this.props.geoMappingActions.buildSamplewtApiOnStudyChange(
        loginResponse.data.uid,
        activeAccountId,
        geoMapStudy.pn,
        weightType.wt,
        weightType.dv,
        studyChangeSampleWtExpList,
        getTabNameForSamplewtApi(geoMapTarget, geoMapBase),
      ).then(data => {
        const sampleWtFinalData = [];
        if (data.selectedTab === 'targetAndBase') {
          sampleWtFinalData.push({
            selectedTab: 'target', data: data.data[2] });
          sampleWtFinalData.push({
            selectedTab: 'base', data: data.data[1] });
        } else {
          sampleWtFinalData.push({
            ...data,
            data: data.data[0],
          });
        }
        const { geoMapTargetGridData, geoMapBaseGridData } = modifiedBaseAndTargetGridData(
          sampleWtFinalData,
          geoMapTarget,
          geoMapBase);
        this.props.geoMappingActions.updateBaseAndTargetOnStudyChange(
          geoMapTargetGridData, geoMapBaseGridData).then(() => {
            this.props.resetAndUpdateGeoMapData();
          });
      });
    }
  }

  studyChangeApiCallsFn = geoMapStudy => {
    const { loginResponse, activeAccountId, geoWeightTypes, geoMapTarget, geoMapBase,
      geographicsTableData } = this.props;
    const studyChangeApis = [];
    const studyChangeSampleWtExpList = getBaseAndTargetExpListOnStudyChange(geoMapTarget,
       geoMapBase);
    if (geoMapTarget.length > 0 || geoMapBase.length > 0) {
      studyChangeApis.push(this.props.geoMappingActions.buildSamplewtApiOnStudyChange(
        loginResponse.data.uid,
        activeAccountId,
        geoMapStudy.pn,
        geoWeightTypes.wt,
        geoWeightTypes.dv,
        studyChangeSampleWtExpList,
        getTabNameForSamplewtApi(geoMapTarget, geoMapBase),
      ));
    }
    const geoRequestsDataOnStudyChange = getTableRequestsDataOnStudyChange(geographicsTableData);
    const tabName = SELECT_GEOGRAPHICS_TAB_OPTIONS.map(item => item.value);
    forEach(tabName, item => {
      const geoRequest = geoRequestsDataOnStudyChange[item];
      if (geoRequest.length > 0) {
        const index = findIndex(GEOGRAPHICS_TOP_NODE_VALUES_ON_STUDY_CHANGE, item);
        const topNodeVal = GEOGRAPHICS_TOP_NODE_VALUES_ON_STUDY_CHANGE[index][item];
        const selectedTab = item;
        studyChangeApis.push(this.props.geoMappingActions.buildGeoTableApiOnStudyChange(
          loginResponse.data.uid,
          activeAccountId,
          geoMapStudy.pn,
          topNodeVal,
          geoRequest,
          selectedTab,
          ));
      }
    });
    return studyChangeApis;
  };

  render() {
    const { studies, getSampleWeighted, fetchKPI, removeKPI, geoMapStudy, gridData,
      handleGeoMapMove, targetBtnDisabled, baseBtnDisabled, expApiQueue }
      = this.props;
    const tags = this.updatedSmartSearch.current ? this.updatedSmartSearch.current.state.tags : [];
    const validExpression = this.updatedSmartSearch.current ?
    this.updatedSmartSearch.current.state.validExpression : [];
    return (
      <div>
        {this.state.studyChangeInvalidData.length > 0 && (
          <div data-test="studyChangePopup">
            <Modal
              title="Changing Studies"
              ref={node => {
                this.studyModal = node;
                return this.studyModal;
              }}
              dialogStyles={modalStyle}
              closeTracker={this.handleCancelClickOnStudyChange}
            >
              <div className="text-center">
                <div>
                  <GeoMapStudyChangePopup
                    studyChangeInvalidData={this.state.studyChangeInvalidData}
                    handleCancelClickOnStudyChange={
                      this.handleCancelClickOnStudyChange
                    }
                    handleValidateContinueClickOnStudyChange={
                      this.handleValidateContinueClickOnStudyChange
                    }
                  />
                </div>
              </div>
            </Modal>
          </div>
        )}
        <div className="smart-search-editor">
          <div className="appBreadcrumb">
            <div className="crosstab-study-selector">
              <CommonStudySelector
                studies={studies}
                featureID={GEOMAPPING_FEATUREID}
                defaultStudy={geoMapStudy}
                setMethod={this.onStudyChange}
                handleChangeWeightType={this.handleChangeWeightType}
                showWeightType
                menuName={GEO_MAP_MODULE}
                selectedWeightType={this.props.geoWeightTypes}
                commonStudySelectorRef={ref => {
                  this.commonStudySelectorRef = ref;
                  return this.commonStudySelectorRef;
                }}
              />
            </div>
            <div className="essential-breadcrumb">
              <span className="parent">{PARENT_MODULE}</span>
              {GEOMAPPING_BREADCRUMB}
            </div>
          </div>
          <div>
            <SmartSearch
              data-test="smartsearch"
              selectedModule={GEO_MAP_MODULE}
              moduleStudy={geoMapStudy}
              getSampleWeighted={getSampleWeighted}
              fetchKPI={fetchKPI}
              removeKPI={removeKPI}
              gridData={gridData}
              ref={this.updatedSmartSearch}
              isTagInputExpanded={this.state.isTagInputExpanded}
            />
            <div className="move-to-geomap-wrapper">
              <div className="button-group">
                <button
                  type="button"
                  className="mri-geomapping-btn"
                  onClick={() => this.setTagInputData()}
                  title="Expand Smart Search"
                >
                  <img
                    className="mri-geomapping-btn-icon-expand"
                    src={
                      this.state.enlargeIcon ? enlargeIcon : enlargeHoverIcon
                    }
                    alt="Enlarge icon"
                  />
                  <p className="mri-geomapping-btn-label">EXPAND</p>
                </button>
                <button
                  type="button"
                  className="mri-geomapping-btn"
                  onClick={() =>
                    handleGeoMapMove('BaseDataGrid', this.updatedSmartSearch)
                  }
                  title="Move to bases"
                  disabled={
                    !tags.length ||
                    (tags.length && !validExpression) ||
                    baseBtnDisabled ||
                    (tags.length === 0 && expApiQueue.length === 0)
                  }
                >
                  <img
                    className="mri-geomapping-btn-icon-expand"
                    src={this.state.basesIcon ? basesIcon : basesHoverIcon}
                    alt="Move to bases"
                  />
                  <p className="mri-geomapping-btn-label">BASES</p>
                </button>
                <button
                  type="button"
                  className="mri-geomapping-btn"
                  onClick={() =>
                    handleGeoMapMove('TargetDataGrid', this.updatedSmartSearch)
                  }
                  title="Move to target"
                  disabled={
                    !tags.length ||
                    (tags.length && !validExpression) ||
                    targetBtnDisabled ||
                    (tags.length === 0 && expApiQueue.length === 0)
                  }
                >
                  <img
                    className="mri-geomapping-btn-icon-expand"
                    src={this.state.targetIcon ? targetIcon : targetHoverIcon}
                    alt="Move to target"
                  />
                  <p className="mri-geomapping-btn-label">TARGET</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GeoMapSmartSearchEditor.propTypes = {
  geoMapTarget: PropTypes.arrayOf(PropTypes.object),
  studies: PropTypes.arrayOf(PropTypes.shape({})),
  getSampleWeighted: PropTypes.func,
  handleGeoMapMove: PropTypes.func,
  fetchKPI: PropTypes.func,
  geoMapStudy: PropTypes.shape({
    pn: PropTypes.number
  }),
  gridData: PropTypes.shape({}),
  selectedReport: PropTypes.shape({}),
  baseBtnDisabled: PropTypes.bool,
  targetBtnDisabled: PropTypes.bool,
  removeKPI: PropTypes.func,
  geoWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number
  }),
  handleStudyChange: PropTypes.func,
  resetAndUpdateGeoMapData: PropTypes.func,
  geoMapBase: PropTypes.arrayOf(PropTypes.object),
  geoMappingActions: PropTypes.shape({
    buildSamplewtApiOnStudyChange: PropTypes.func,
    buildGeoTableApiOnStudyChange: PropTypes.func,
    updateBaseAndTargetOnStudyChange: PropTypes.func,
    getGeoghrapicsData: PropTypes.func,
    setGeoghrapicsTableDataThunk: PropTypes.func,
    setParentChildCountMapThunk: PropTypes.func,
    resetGeographicsTableDataWithZeros: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
    }),
  }),
  geographicsTableData: PropTypes.instanceOf(Object),
  activeAccountId: PropTypes.number,
  // handleCancelClickOnStudyChange: PropTypes.func,
  updateWeightType: PropTypes.func,
  parentChildCountMap: PropTypes.instanceOf(Object),
  expApiQueue: PropTypes.instanceOf(Object),
};

function mapStateToProps(state) {
  return {
    selectedReport: state.geomap.selectedReport,
    geoMapTarget: state.geomap.TargetDataGridData,
    geoWeightTypes: state.study.geoWeightTypes,
    geoMapBase: state.geomap.BaseDataGridData,
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    geographicsTableData: state.geomap.geographicsTableData,
    parentChildCountMap: state.geomap.parentChildCountMap,
    kpisTitle: state.geomap.selectedKPIsTitle,
    expApiQueue: state.geomap.expApiQueue,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    geoMappingActions: bindActionCreators(geoMappingActions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(GeoMapSmartSearchEditor);

